module.exports = __webpack_public_path__ + "static/media/chicken-pot-pie-noodles.c453d15f.png";